import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

// ========== ATTENDANCE REPORT SERVICES==========
export const getAttendanceReport = async (data: any) => {
	const URL = `${API_URL}GetAttendanceReport`;
	const requestData = {
		CreateAttendanceReportToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== LEAVE REPORT SERVICES==========
export const getLeaveReport = async (data: any) => {
	const URL = `${API_URL}GetLeaveReport`;
	const requestData = {
		CreateLeaveReportToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== SECTION WISE ATTENDANCE REPORT SERVICES==========
export const getSectionWiseAttendanceReport = async (data: any) => {
	const URL = `${API_URL}GetSectionWiseAttendanceReport`;
	const requestData = {
		CreateSectionWiseAttendanceReportToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== MANAGEMENT LEAVE REPORT SERVICE ==========
export const getManagementLeaveReport = async (data: any) => {
	const URL = `${API_URL}GetManagementLeaveReport`;
	const requestData = {
		CreateManagementLeaveReportToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== DESIGNATION WISE LEAVE REPORT SERVICE ==========
export const getDesignationWiseLeaveReport = async (data: any) => {
	const URL = `${API_URL}GetDesignationWiseLeaveReport`;
	const requestData = {
		CreateDesignationWiseLeaveReportToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== EMPLOYEE LEAVE REPORT SERVICE ==========
export const getEmployeeLeaveReport = async (data: any) => {
	const URL = `${API_URL}GetEmployeeLeaveReport`;
	const requestData = {
		CreateEmployeeLeaveReportToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== MONTHLY ATTENDANCE SUMMARY REPORT SERVICE ==========
export const getMonthlyAttendanceSummaryReport = async (data: any) => {
	const URL = `${API_URL}GetMonthlyAttendanceSummaryReport`;
	const requestData = {
		CreateMonthlyAttendanceSummaryReportToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== MONTHLY CHECKOUT REPORT SERVICE ==========
export const getMonthlyCheckoutReport = async (data: any) => {
	const URL = `${API_URL}GetMonthlyCheckoutReport`;
	const requestData = {
		CreateMonthlyCheckoutReportToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== MONTHLY CHECKOUT DETAILS SERVICE ==========
export const getMonthlyCheckoutDetailsReport = async (data: any) => {
	const URL = `${API_URL}GetMonthlyReportDetails`;
	const requestData = {
		CreateMonthlyReportDetailsToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== COMP OFF REPORT SERVICE ==========
export const getCompOffReport = async (data: any) => {
	const URL = `${API_URL}GetAllCompOffByOrg`;
	const requestData = {
		GetAllCompOffByOrgToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== APPROVE COMP OFF BY HR SERVICE ==========
export const approveCompOffByHR = async (data: any) => {
	const URL = `${API_URL}ApproveCompOffByHR`;
	const requestData = {
		ApproveCompOffByHRToken: data,
	};
	return makeApiCall(URL, requestData, 'POST');
};

// ========== REFRESHMENT REPORT SERVICE ==========
export const getRefreshmentReport = async (data: any) => {
	const URL = `${API_URL}GetRefreshmentAllowancesByOrganisationID`;
	const requestData = {
		GetRefreshmentAllowancesByOrganisationIDToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== ON DUTY REPORT SERVICE ==========
export const getOnDutyReport = async (data: any) => {
	const URL = `${API_URL}GetOnDutyReport`;
	const requestData = {
		CreateOnDutyReportToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== GET ALL EMPLOYEES CHECK-IN/CHECK-OUT SERVICE ==========
export const getAllEmployeesCheckInOut = async (data: any) => {
	const URL = `${API_URL}GetAllEmployeesCheckInOut`;
	const requestData = {
		GetAllEmployeesCheckInOutToken: data,
	};
	return makeApiCall(URL, requestData);
};

// ========== CHECK-IN LOCKED SERVICES START ==========
export const checkInLockedService = async (data: any) => {
	const URL = `${API_URL}getAllCheckInLockedEmployees`;
	const requestData = {
		CreateCheckInLockedReportToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const checkInLockedHistoryService = async (data: any) => {
	const URL = `${API_URL}getAllCheckInLockedEmpHistory`;
	const requestData = {
		CreateCheckInLockedHistoryReportToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const checkInLockedExcuseService = async (data: any) => {
	const URL = `${API_URL}unlockCheckInLockedEmployee`;
	const requestData = {
		CreateCheckInLockedExcuseToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const checkInUnLockedHistoryService = async (data: any) => {
	const URL = `${API_URL}getAllUnLockEmpHistory`;
	const requestData = {
		CreateCheckInUnlockedHistoryReportToken: data,
	};
	return makeApiCall(URL, requestData);
};
// ========== CHECK-IN LOCKED SERVICES END ==========

// ========== FESTIVAL ADVANCE REPORT SERVICE ==========
export const getFestivalAdvanceReport = async (data: any) => {
	const URL = `${API_URL}GetFestivalAdvanceReport`;
	const requestData = {
		CreateFestivalAdvanceReportToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const getAllFestivalNames = async (data: any) => {
	const URL = `${API_URL}GetAllFestivalNames`;
	const requestData = {
		GetAllFestivalNamesToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const updateFestivalAdvanceStatus = async (data: any) => {
	const URL = `${API_URL}UpdateFestivalAdvanceStatus`;
	const requestData = {
		UpdateFestivalAdvanceStatusToken: data,
	};
	return makeApiCall(URL, requestData);
};
// ========== FESTIVAL ADVANCE REPORT SERVICE END ==========

// ========== MEDICAL ALLOWANCE REPORT SERVICE ==========
export const getMedicalAllowanceReport = async (data: any) => {
	const URL = `${API_URL}GetMedicalAllowanceReport`;
	const requestData = {
		CreateMedicalAllowanceReportToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const updateMedicalAllowanceStatus = async (data: any) => {
	const URL = `${API_URL}UpdateMedicalAllowanceStatus`;
	const requestData = {
		UpdateMedicalAllowanceStatusToken: data,
	};
	return makeApiCall(URL, requestData);
};
// ========== MEDICAL ALLOWANCE REPORT SERVICE END ==========